import ContentLayout from "../components/layout/ContentLayout";
import OverviewForm from "../components/OverviewForm";

export default function AccountsForm() {
  return (
    <ContentLayout
      header={
        <>
          <h1>
            Welcome <br />
            <span>Jack Owner</span>
          </h1>
        </>
      }
    >
      <OverviewForm />
    </ContentLayout>
  );
}
